module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-swap-gray-4d7dce.svg";